<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
	<g fill="#fff00">
		<path
			d="M20.756 7.343c0-1.065-.836-1.931-1.865-1.931h-5.882l1.348-2.992a.656.656 0 0 0-.3-.857.614.614 0 0 0-.832.312l-1.189 2.641-1.188-2.641a.615.615 0 0 0-.827-.312.656.656 0 0 0-.3.857l1.348 2.992H5.11c-1.029 0-1.865.866-1.865 1.931v8.378h17.51zm-7.517 6.398a.53.53 0 0 1-.766 0 .6.6 0 0 0-.869 0 .53.53 0 0 1-.766 0 .575.575 0 0 1 0-.793 1.65 1.65 0 0 1 2.396 0 .57.57 0 0 1 .005.793m1.63-1.689a.53.53 0 0 1-.765 0 2.853 2.853 0 0 0-4.135 0 .53.53 0 0 1-.766 0 .575.575 0 0 1 0-.793 3.91 3.91 0 0 1 5.666 0 .575.575 0 0 1 0 .793m1.635-1.693a.53.53 0 0 1-.766 0 5.106 5.106 0 0 0-7.4 0 .53.53 0 0 1-.765 0 .575.575 0 0 1 0-.793 6.163 6.163 0 0 1 8.931 0 .575.575 0 0 1 0 .793M2 17.016v5.843a.63.63 0 0 0 .62.642h2.612a.63.63 0 0 0 .62-.642v-3.221h12.286v3.22a.63.63 0 0 0 .62.643h2.612a.63.63 0 0 0 .62-.642v-5.843z"
		/>
	</g>
</svg>
